import React, { useMemo } from 'react';
import ProjectCard from './ProjectCard';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Portfolio = () => {
  // ✅ FIX: Wrap the projects array in useMemo to stabilize it.
  // The empty dependency array `[]` ensures this runs only once.
  const projects = useMemo(() => [
    {
      title: 'Retain Branding',
      description: "Revamped and refined the branding of Retain Loyalty's marketing materials to ensure consistency, clarity, and alignment with the company’s vision.",
      imgSrc: '/images/retain-brand.jpg',
    },
    {
      title: "Klingstedt Brother's Business Trifold",
      description: 'Tasked with redesigning a business services trifold for The Klingstedt Brothers Co., the oldest commercial printer in Canton, OH.',
      imgSrc: '/images/kb-trifold.jpg',
    },
    {
      title: 'Rubber City Classic Tournament Branding',
      description: 'This was a total package created for a B-Tier disc golf tournament in Norton, OH. Including branding, signage, and promotional materials. One of the featured items was a caddy book with hole maps, sponsor ads, and course information.',
      imgSrc: '/images/rcc-branding.jpg',
    }
  ], []); // <-- Empty array means it's created only once

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  };

  // ✅ Now this useMemo hook works correctly because its `projects`
  // dependency is stable and won't change on re-renders.
  const projectCards = useMemo(() => {
    return projects.map((project, index) => (
      <ProjectCard
        key={index}
        title={project.title}
        description={project.description}
        imgSrc={project.imgSrc}
      />
    ));
  }, [projects]);

  return (
    <div className="three-card-spacing h-screen flex flex-col justify-center">
      <div className="container mx-auto px-0 md:px-6 text-center">
        <h2 className="text-gray-800 text-4xl font-bold inline border-b-4 border-cyan-500 pb-12">Recent Work</h2>
        <div className="flex justify-center pt-12">
          <div className="hidden sm:block">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 pb-12">
              {projectCards}
            </div>
          </div>
          <div className="sm:hidden w-full pb-12">
            <Slider {...settings}>
              {projectCards}
            </Slider>
          </div>
        </div>
        <div className="mt-10">
          <a
            href="/work"
            className="w-1/3 text-md bg-cyan-500 hover:bg-cyan-700 text-white  py-2 px-4 rounded mt-5 ml-4"
          >
            See More
          </a>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;